var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoundMax(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23721 9.86753C1.73216 9.02579 1.73216 7.97421 2.2372 7.13247C2.39132 6.87561 2.64665 6.69567 2.94038 6.63693L4.13961 6.39708C4.21106 6.38279 4.27546 6.34447 4.3221 6.2885L4.96253 5.51999C6.14509 4.10092 6.73637 3.39138 7.26403 3.58242C7.79169 3.77346 7.79169 4.69707 7.79169 6.54428L7.79169 10.4557C7.79169 12.3029 7.79169 13.2265 7.26403 13.4176C6.73637 13.6086 6.14509 12.8991 4.96253 11.48L4.3221 10.7115C4.27546 10.6555 4.21106 10.6172 4.13961 10.6029L2.94038 10.3631C2.64665 10.3043 2.39132 10.1244 2.23721 9.86753Z",
    stroke: "#222222",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0043 5.99567C11.6651 6.65645 12.0379 7.55159 12.0416 8.48606C12.0453 9.42053 11.6795 10.3186 11.024 10.9845",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9236 4.49307C14.9808 5.55031 15.5774 6.98254 15.5833 8.47769C15.5892 9.97284 15.0039 11.4097 13.9551 12.4753",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundMax);
export default __webpack_public_path__ + "static/media/sound_max.1f9a7ab881f75da5dc7a24aa2226e862.svg";
export { ForwardRef as ReactComponent };